export default "__VITE_ASSET__tWbJ8Ox$__"